import React from "react";

export const AchievmentsFrame = () => {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 348 408"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M341.241 408H313.951L310.43 404.455H292L293.564 402.091H312.427L314.186 403.864H340.883L345.578 395H348L341.241 408Z"
        fill="#7F5CFF"
      />
      <path
        d="M6.75907 408H34.0489L37.5697 404.455H56L54.4357 402.091H35.5735L33.8136 403.864H7.11684L2.42171 395H0L6.75907 408Z"
        fill="#7F5CFF"
      />
      <path
        d="M292.75 402H55.5002L57.0002 404.5H291L292.75 402Z"
        fill="#7F5CFF"
      />
      <path
        d="M341.241 0H313.951L310.43 3.54535H292L293.564 5.90929H312.427L314.186 4.13607H340.883L345.578 13H348L341.241 0Z"
        fill="#7F5CFF"
      />
      <path
        d="M6.75907 0H34.0489L37.5697 3.54535H56L54.4357 5.90929H35.5735L33.8136 4.13607H7.11684L2.42171 13H0L6.75907 0Z"
        fill="#7F5CFF"
      />
      <mask id="path-6-inside-1_3003_23335" fill="white">
        <path d="M35 8.67578H313L315 6H340L344 16.7041H348V391.51H344L340 402H315L313 399.378H35L33 402H9L4 391.51H0V16.7041H4L8 6H33L35 8.67578Z" />
      </mask>
      <path
        d="M35 8.67578L34.199 9.27447L34.499 9.67578H35V8.67578ZM313 8.67578V9.67578H313.501L313.801 9.27447L313 8.67578ZM315 6V5H314.499L314.199 5.40131L315 6ZM340 6L340.937 5.64995L340.694 5H340V6ZM344 16.7041L343.063 17.0541L343.306 17.7041H344V16.7041ZM348 16.7041H349V15.7041H348V16.7041ZM348 391.51V392.51H349V391.51H348ZM344 391.51V390.51H343.311L343.066 391.153L344 391.51ZM340 402V403H340.689L340.934 402.356L340 402ZM315 402L314.205 402.606L314.505 403H315V402ZM313 399.378L313.795 398.771L313.495 398.378H313V399.378ZM35 399.378V398.378H34.5051L34.2049 398.771L35 399.378ZM33 402V403H33.4949L33.7951 402.606L33 402ZM9 402L8.09729 402.43L8.36885 403H9V402ZM4 391.51L4.90271 391.08L4.63115 390.51H4V391.51ZM0 391.51H-1V392.51H0V391.51ZM0 16.7041V15.7041H-1V16.7041H0ZM4 16.7041V17.7041H4.69385L4.93673 17.0541L4 16.7041ZM8 6V5H7.30615L7.06327 5.64995L8 6ZM33 6L33.801 5.40131L33.501 5H33V6ZM35 8.67578V9.67578H313V8.67578V7.67578H35V8.67578ZM313 8.67578L313.801 9.27447L315.801 6.59869L315 6L314.199 5.40131L312.199 8.07709L313 8.67578ZM315 6V7H340V6V5H315V6ZM340 6L339.063 6.35005L343.063 17.0541L344 16.7041L344.937 16.3541L340.937 5.64995L340 6ZM344 16.7041V17.7041H348V16.7041V15.7041H344V16.7041ZM348 16.7041H347V391.51H348H349V16.7041H348ZM348 391.51V390.51H344V391.51V392.51H348V391.51ZM344 391.51L343.066 391.153L339.066 401.644L340 402L340.934 402.356L344.934 391.866L344 391.51ZM340 402V401H315V402V403H340V402ZM315 402L315.795 401.394L313.795 398.771L313 399.378L312.205 399.984L314.205 402.606L315 402ZM313 399.378V398.378H35V399.378V400.378H313V399.378ZM35 399.378L34.2049 398.771L32.2049 401.394L33 402L33.7951 402.606L35.7951 399.984L35 399.378ZM33 402V401H9V402V403H33V402ZM9 402L9.90271 401.57L4.90271 391.08L4 391.51L3.09729 391.94L8.09729 402.43L9 402ZM4 391.51V390.51H0V391.51V392.51H4V391.51ZM0 391.51H1V16.7041H0H-1V391.51H0ZM0 16.7041V17.7041H4V16.7041V15.7041H0V16.7041ZM4 16.7041L4.93673 17.0541L8.93673 6.35005L8 6L7.06327 5.64995L3.06327 16.3541L4 16.7041ZM8 6V7H33V6V5H8V6ZM33 6L32.199 6.59869L34.199 9.27447L35 8.67578L35.801 8.07709L33.801 5.40131L33 6Z"
        fill="#7F5CFF"
        mask="url(#path-6-inside-1_3003_23335)"
      />
      <path d="M292.75 6H55.5002L57.0002 3.5H291L292.75 6Z" fill="#7F5CFF" />
    </svg>
  );
};
